import { axiosClient } from "@lib/services/axios";
import { ENDPOINTS } from "@lib/constants/general";

import { z } from "zod";
import {
  BaseUnitGroupResponse,
  UnitGroupResponse,
} from "@lib/types/unit_group";

export const unitGroupSchema = z.object({
  name: z.string().min(1, "Name is required"),
  units: z.array(z.number()).optional(),
});
export type UnitGroupFormData = z.infer<typeof unitGroupSchema>;

export const createUnitGroup = async (
  createUnitGroupParams: UnitGroupFormData
): Promise<UnitGroupResponse> => {
  const { data } = await axiosClient.post(
    ENDPOINTS.BASE_UNIT_GROUPS,
    createUnitGroupParams
  );
  return data;
};
export const updateUnitGroup = async ({
  unitGroupId,
  updateUnitGroupParams,
}: {
  unitGroupId: number;
  updateUnitGroupParams: UnitGroupFormData;
}): Promise<BaseUnitGroupResponse> => {
  const { data } = await axiosClient.put(
    `${ENDPOINTS.BASE_UNIT_GROUPS}/${unitGroupId}`,
    updateUnitGroupParams
  );
  return data;
};
